import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Avatar, Box, Button, Checkbox, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, LinearProgress, List, ListItem, ListItemAvatar, ListItemText } from '@material-ui/core';
import { Folder } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import FileExplorer from '../components/FileExplorer';
import { useMoveFile } from '../hooks/useMoveFile';
const StyledList = styled(List) `
  padding: 0;
  margin-top: ${props => props.theme.spacing(2)};
  background-color: ${props => props.theme.palette.grey[100]};
  .primary {
    background-color: ${props => props.theme.palette.primary.main};
  }
`;
const DocumentMoveDialog = props => {
    const { open, fileIds, onMove, onCancel } = props;
    const onMoveRef = useRef(onMove);
    const [error, setError] = useState();
    const [destination, setDestination] = useState();
    const [checkReplace, setCheckReplace] = useState(false);
    const { data, isLoading, error: moveError, moveFile } = useMoveFile();
    const isDestinationValid = !!(destination &&
        (destination.id === null || destination.id > 0));
    useEffect(() => {
        onMoveRef.current = onMove;
    }, [onMove]);
    // reset state on toggle dialog
    useEffect(() => {
        if (!open) {
            setError(undefined);
            setCheckReplace(false);
            setDestination(undefined);
        }
    }, [open]);
    useEffect(() => {
        var _a;
        if (data) {
            (_a = onMoveRef.current) === null || _a === void 0 ? void 0 : _a.call(onMoveRef);
        }
    }, [data]);
    useEffect(() => {
        setError(moveError);
    }, [moveError]);
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: onCancel },
        isLoading && React.createElement(LinearProgress, null),
        React.createElement(DialogTitle, null,
            "Move ",
            fileIds.length > 1 ? 'Files' : 'File'),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, null, "Pick a folder:"),
            React.createElement(FileExplorer, { hideTrashDir: true, onSelectFile: setDestination }),
            React.createElement(Collapse, { in: !!destination, style: { minHeight: 'unset' } },
                React.createElement(Box, { mt: 2, boxShadow: 1 },
                    React.createElement(StyledList, { dense: true },
                        React.createElement(ListItem, null,
                            React.createElement(ListItemAvatar, null,
                                React.createElement(Avatar, { className: 'primary' },
                                    React.createElement(Folder, null))),
                            React.createElement(ListItemText, { primary: (destination === null || destination === void 0 ? void 0 : destination.name) || '?', secondary: 'Selected files will be moved here.' }))))),
            React.createElement(Collapse, { in: !!error, style: { minHeight: 'unset' } },
                React.createElement(Box, { mt: 2 },
                    React.createElement(Alert, { severity: 'error' }, error === null || error === void 0 ? void 0 : error.message)))),
        React.createElement(DialogActions, null,
            React.createElement(FormControlLabel, { style: { marginLeft: 0 }, label: 'Replace files with same name', control: React.createElement(Checkbox, { color: 'primary', name: 'checkReplace', disabled: isLoading, checked: checkReplace, onChange: () => setCheckReplace(!checkReplace) }) }),
            React.createElement("div", { style: { flex: 1 } }),
            React.createElement(Button, { disabled: isLoading, onClick: onCancel }, "Close"),
            React.createElement(Button, { type: 'submit', color: 'primary', variant: 'contained', disabled: isLoading || !isDestinationValid, onClick: () => {
                    if (fileIds.length > 0 && destination && isDestinationValid) {
                        moveFile({
                            ids: fileIds,
                            destinationFolderId: destination.id,
                            shouldUpdateIfExists: checkReplace
                        });
                    }
                } }, "Move"))));
};
export default DocumentMoveDialog;
//# sourceMappingURL=DocumentMoveDialog.js.map